import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const LOGO =
    "https://customer-assets.emergentagent.com/job_2dd4774c-00c6-45cd-8263-5e60a2df322d/artifacts/jfrbne5i_WhatsApp%20Image%202026-04-24%20at%204.31.50%20PM.jpeg";

const NAV = [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Course", href: "#course" },
    { label: "Admission", href: "#admission" },
    { label: "Gallery", href: "#gallery" },
    { label: "Contact", href: "#contact" },
];

export const Header = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled ? "glass-header py-3" : "bg-transparent py-5"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 flex items-center justify-between">
                <a href="#home" data-testid="header-logo-link" className="flex items-center gap-3 group">
                    <img
                        src={LOGO}
                        alt="Prasad Rudrik College of Pharmaceutical Sciences"
                        className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover ring-2 ring-white shadow-md group-hover:scale-105 transition-transform"
                    />
                    <div className="hidden sm:block leading-tight">
                        <div
                            className={`font-display text-base md:text-lg font-semibold transition-colors ${
                                scrolled ? "text-stone-900" : "text-white drop-shadow"
                            }`}
                        >
                            Prasad Rudrik
                        </div>
                        <div
                            className={`text-[10px] md:text-[11px] tracking-[0.18em] uppercase transition-colors ${
                                scrolled ? "text-stone-500" : "text-white/80"
                            }`}
                        >
                            College of Pharmaceutical Sciences
                        </div>
                    </div>
                </a>

                <nav className="hidden lg:flex items-center gap-8">
                    {NAV.map((n) => (
                        <a
                            key={n.label}
                            href={n.href}
                            data-testid={`nav-link-${n.label.toLowerCase()}`}
                            className={`text-sm font-medium link-underline transition-colors ${
                                scrolled ? "text-stone-700 hover:text-[var(--brand-green)]" : "text-white/90 hover:text-white"
                            }`}
                        >
                            {n.label}
                        </a>
                    ))}
                    <a
                        href="#admission"
                        data-testid="header-apply-cta"
                        className="btn-primary !py-2.5 !px-5 text-sm"
                    >
                        Apply Now
                        <i className="fa-solid fa-arrow-right text-xs" />
                    </a>
                </nav>

                <button
                    onClick={() => setOpen(true)}
                    data-testid="mobile-menu-open"
                    className={`lg:hidden p-2 rounded-md ${scrolled ? "text-stone-800" : "text-white"}`}
                    aria-label="Open menu"
                >
                    <Menu size={26} />
                </button>
            </div>

            {/* Mobile drawer */}
            {open && (
                <div className="lg:hidden fixed inset-0 z-[60]">
                    <div
                        className="absolute inset-0 bg-stone-900/50"
                        onClick={() => setOpen(false)}
                        data-testid="mobile-menu-backdrop"
                    />
                    <div className="absolute right-0 top-0 h-full w-[82%] max-w-sm bg-white shadow-2xl p-6 flex flex-col">
                        <div className="flex items-center justify-between mb-8">
                            <div className="flex items-center gap-2">
                                <img src={LOGO} alt="" className="w-10 h-10 rounded-full object-cover" />
                                <span className="font-display text-lg font-semibold">Prasad Rudrik</span>
                            </div>
                            <button
                                onClick={() => setOpen(false)}
                                data-testid="mobile-menu-close"
                                className="p-2 rounded-md hover:bg-stone-100"
                                aria-label="Close menu"
                            >
                                <X size={24} />
                            </button>
                        </div>
                        <nav className="flex flex-col gap-1">
                            {NAV.map((n) => (
                                <a
                                    key={n.label}
                                    href={n.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                                    className="px-3 py-3 rounded-lg text-stone-800 hover:bg-stone-100 font-medium"
                                >
                                    {n.label}
                                </a>
                            ))}
                        </nav>
                        <div className="mt-auto space-y-3">
                            <a
                                href="tel:8637584851"
                                data-testid="mobile-call-cta"
                                className="flex items-center gap-3 px-3 py-3 rounded-lg bg-stone-50 border border-stone-200"
                            >
                                <Phone size={18} className="text-[var(--brand-green)]" />
                                <span className="text-sm">8637584851 / 8509650147</span>
                            </a>
                            <a
                                href="#admission"
                                onClick={() => setOpen(false)}
                                data-testid="mobile-apply-cta"
                                className="btn-primary w-full justify-center"
                            >
                                Apply Now
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
